import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SfeMenuControllerService {

  private onRefresh$: Subject<void> = new Subject();

  constructor() { }

  asObservable() {
    return this.onRefresh$.asObservable();
  }

  complete() {
    this.onRefresh$.complete();
  }

  refresh() {
    this.onRefresh$.next();
  }
}
